export default "/signup/_next/static/chunks/fonts/ProximaNova-Bold-67f7e46a3ea18962d42f894834a9820b.otf";